import { MEDIA_QUERY_CONDITION_FOR_PC } from "../mediaQueryForPc";
export const MEDIA_QUERY_FOR_SP = `@media screen and (max-width: ${MEDIA_QUERY_CONDITION_FOR_PC.minWidth - 1}px)`;
